import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

export type DocumentPreviewSkeletonVariant = "full" | "content";

export interface DocumentPreviewSkeletonProps {
  /** "full" adds a fake toolbar row above the text lines; "content" is text lines only,
   * for use inside a viewer that already renders its own real toolbar. */
  variant: DocumentPreviewSkeletonVariant;
}

export const DocumentPreviewSkeleton = ({ variant }: DocumentPreviewSkeletonProps) => (
  // w-full matters in flex-centered parents (e.g. the pdf-viewer loader wrapper): without it
  // the root shrinks to fit and the percentage-width lines collapse to zero.
  <div className="flex h-full w-full flex-col">
    {variant === "full" ? (
      <div className="flex h-11 shrink-0 items-center justify-between border-b border-border bg-surface-subtle px-3">
        <div className="flex items-center gap-2">
          <Skeleton width={110} height={14} />
          <Skeleton width={1} height={16} />
          <Skeleton width={52} height={14} />
        </div>
        <div className="flex items-center gap-2">
          <Skeleton width={24} height={24} borderRadius={4} />
          <Skeleton width={24} height={24} borderRadius={4} />
          <Skeleton width={1} height={16} />
          <Skeleton width={24} height={24} borderRadius={4} />
        </div>
      </div>
    ) : null}
    <div className="flex flex-col gap-2.5 p-6">
      <Skeleton width="50%" height={16} />
      <Skeleton count={3} height={13} containerClassName="mb-1" />
      <Skeleton width="66%" height={13} />
      <Skeleton count={3} height={13} containerClassName="mt-2 mb-1" />
      <Skeleton width="75%" height={13} />
      <Skeleton count={2} height={13} containerClassName="mt-2 mb-1" />
      <Skeleton width="55%" height={13} />
    </div>
  </div>
);
